// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sDS3U","field":"styles_field__gyGBs","fieldCol":"styles_fieldCol__2aMie","diffCol":"styles_diffCol__1R74M","diff":"styles_diff__3-iAR"};